import {
  GridColDef,
  GridColumns,
  GridRenderCellParams,
  GridRowParams
} from '@mui/x-data-grid-premium';
import { IPurchaseRequest } from 'interfaces';
import CustomizedSteppers from 'components/common/RequestStatus';
import SectionTitle from 'components/common/SectionTitle';
import {
  isTenantAdministrator,
  IsTenantAdministrator
} from 'components/helpers/IsTenantAdministrator';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { dateCell } from '../cells/date-cell';
import {
  booleanFilterOperators,
  dateFilterOperators,
  filterOperators
} from '../../../../constants';
import ConfirmationDeleteTableDialog from 'components/helpers/ConfirmationGridDelete';
import { booleanCell } from '../cells/boolean-cell';

export function PurchaseLineColumns(message: string, handleDelete?: any): GridColDef[] {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const translationPrefix = 'pages.purchase-requests.list';
  const isAdmin = isTenantAdministrator();

  const columns: GridColumns = [
    {
      field: 'id',
      headerName: t('entities.purchase-request.ID'),
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        const pr = params.row as IPurchaseRequest;
        const isDisabled = !isAdmin && pr.automatic_generated;

        const linkContent = (
          <SectionTitle>
            {t(`${translationPrefix}.request-description`, { id: pr.id })}
          </SectionTitle>
        );

        if (isDisabled) {
          return (
            <span style={{ color: '#888', cursor: 'not-allowed' }} title="Accesso limitato">
              {linkContent}
            </span>
          );
        }

        return (
          <a
            onClick={() =>
              navigate(`${params.row.automatic_generated ? 'automatic/' : ''}view/${params.row.id}`)
            }
            style={{ cursor: 'pointer' }}>
            {linkContent}
          </a>
        );
      }
    },
    {
      field: 'created_by',
      headerName: t('entities.purchase-request.proposer'),
      filterOperators
    },
    {
      field: 'created_at',
      width: 200,
      headerName: t('entities.purchase-request.created_at'),
      filterOperators: dateFilterOperators,
      renderCell: dateCell
    },
    {
      field: 'automatic_generated',
      headerName: t('entities.purchase-request.automatic'),
      type: 'boolean',
      filterable: true,
      filterOperators: booleanFilterOperators,
      renderCell: booleanCell(t)
    },
    {
      field: 'status',
      width: 200,
      headerName: t('entities.purchase-request.status'),
      filterable: false,
      renderCell: (props: GridRenderCellParams) => {
        const pr = props.row as IPurchaseRequest;
        return (
          <div className="w-full flex flex-row justify-end items-center">
            <div className="w-60">
              <CustomizedSteppers status={pr.status}></CustomizedSteppers>
            </div>
          </div>
        );
      }
    },
    {
      field: '',
      flex: 1,
      headerName: t('global.actions'),
      align: 'right',
      type: 'actions',
      getActions: (params: GridRowParams) => {
        return [
          <IsTenantAdministrator key={2}>
            <ConfirmationDeleteTableDialog
              handleDelete={handleDelete}
              message={message}
              id={+params.id}
            />
          </IsTenantAdministrator>
        ];
      }
    }
  ];
  return columns;
}
